<template>
  <tab-item-template>
    <template #toolbar-items>
      <el-tooltip placement="bottom" content="再読込">
        <v-btn icon @click="doLoad()">
          <v-icon>mdi-reload</v-icon>
        </v-btn>
      </el-tooltip>
      <v-spacer/>
      <toolbar-inline>
        <trade-contract-filter
            @apply-filter="tradeContractFilter = $event"
            :trade-contracts="tradeContractsView">
        </trade-contract-filter>
      </toolbar-inline>
      <toolbar-inline>
        <v-text-field
            v-model="filterText"
            clearable
            placeholder="検索">
        </v-text-field>
      </toolbar-inline>
    </template>

    <el-table
        :data="tradeContractsViewFiltered"
        :default-sort="{prop: 'createdAt', order: 'descending'}"
        :height="tabItemBounds.height"
        border>
      <el-table-column
          width="250"
          prop="name"
          label="取引契約名"
          fixed="left"
          :sort-method="buildSort(row => row.name)"
          sortable>
        <template #default="{row}">
          <table-inline>
            <text-field-like
                :value="row.name"
                :value-id="row.id">
            </text-field-like>
          </table-inline>
        </template>
      </el-table-column>

      <el-table-column
          width="100"
          align="center"
          prop="statusText"
          label="状態"
          sortable>
      </el-table-column>

      <el-table-column
          min-width="150"
          prop="companionOwnerName"
          label="取引先事業者"
          :sort-method="buildSort(row => row.companionOwnerName)"
          sortable>
        <template #default="{row}">
          <table-inline v-if="row.companionTerminalName">
            <text-field-like
                style="font-size: 85%;"
                :value="row.companionTerminalName">
            </text-field-like>
          </table-inline>
          <table-inline>
            <text-field-like
                :value="row.companionOwnerName"
                placeholder="相手側で未承認">
            </text-field-like>
          </table-inline>
        </template>
      </el-table-column>

      <el-table-column
          width="80"
          align="center"
          prop="amiIssuer"
          label="方向"
          sortable>
        <template #default="{row}">
          <template v-if="row.amiIssuer">
            <span>発行</span>
            <el-tooltip placement="right">
              <template #content>
                {{ account.owner.name }}が発行しました
              </template>
              <template #default>
                <v-icon small color="blue" class="ml-1">mdi-information</v-icon>
              </template>
            </el-tooltip>
          </template>
          <template v-if="row.amiRecipient">
            <span>受領</span>
            <el-tooltip placement="right">
              <template #content>
                {{ account.owner.name }}が受領しました
              </template>
              <template #default>
                <v-icon small color="blue" class="ml-1">mdi-information</v-icon>
              </template>
            </el-tooltip>
          </template>
        </template>
      </el-table-column>

      <el-table-column
          min-width="200"
          prop="tradeContractSource.dataComponentModelName"
          label="データ構成モデル名"
          :sort-method="buildSort(row => row.tradeContractSource.dataComponentModelName)"
          sortable>
        <template #default="{row}">
          <table-inline>
            <text-field-like
                :value="row.tradeContractSource.dataComponentModelName"
                :message="row.tradeContractSource.dataComponentModelDictionaryName"
                placeholder="未選択">
            </text-field-like>
          </table-inline>
        </template>
      </el-table-column>

      <el-table-column
          min-width="130"
          prop="tradeContractSource.dataImplementation.controller.name"
          label="コントローラ"
          sortable>
        <template #default="{row}">
          <table-inline>
            <text-field-like
                :value="row.tradeContractSource.dataImplementation
                ? row.tradeContractSource.dataImplementation.controller.name
                : null"
                placeholder="未選択">
            </text-field-like>
          </table-inline>
        </template>
      </el-table-column>

      <el-table-column
          width="80"
          align="center"
          prop="serviceTypeText"
          label="区分"
          sortable>
        <template #default="{row}">
          {{ row.serviceTypeText }}
          <el-tooltip placement="right">
            <template #content>
              {{ account.owner.name }}が{{ row.serviceTypeText }}しています
            </template>
            <template #default>
              <v-icon small color="blue" class="ml-1">mdi-information</v-icon>
            </template>
          </el-tooltip>
        </template>
      </el-table-column>

      <el-table-column
          width="100"
          prop="createdAt"
          label="作成日"
          sortable>
        <template #default="{row}">{{ formatDate(row.createdAt) }}</template>
      </el-table-column>

      <el-table-column
          width="60"
          align="center"
          fixed="right"
          column-key="editing"
          v-if="isEditable">
        <template #default="{row}">
          <icon-btns>
            <icon-btn
                type="view"
                :to="{name: '/viewContract', params: {tradeContractId: row.id}}">
            </icon-btn>
          </icon-btns>
        </template>
      </el-table-column>
    </el-table>
  </tab-item-template>
</template>

<script>
import PathInfoMixin from "@/router/PathInfoMixin";
import TabItemTemplate from "@/components/templates/TabItemTemplate.vue";
import Formatter from "@/utils/Formatter";
import TableInline from "@/components/atoms/TableInline.vue";
import TextFieldLike from "@/components/molecules/TextFieldLike.vue";
import {mapGetters} from "vuex";
import IconBtns from "@/components/molecules/IconBtns";
import IconBtn from "@/components/molecules/IconBtn.vue";
import TradeContractFilter from "@/components/organisms/TradeContractFilter.vue";
import IoablePageMixin from "@/router/IoablePageMixin";
import {createTradeContractView} from "@/components/pages/contract/TradeContract/TradeContractView";
import TableUtil from "@/components/pages/contract/TradeContractList/TableUtil";
import ToolbarInline from "@/components/atoms/ToolbarInline.vue";

export default {
  name: 'SuspendedTab',
  mixins: [
    PathInfoMixin,
    IoablePageMixin,
    Formatter,
    TableUtil,
  ],
  components: {
    TradeContractFilter,
    IconBtn,
    IconBtns,
    TextFieldLike,
    TableInline,
    TabItemTemplate,
    ToolbarInline
  },
  inject: ['tabItemBounds'],
  data() {
    return {
      tradeContracts: [],
      tradeContractFilter: () => true,
      filterText: '',
    }
  },
  computed: {
    ...mapGetters({
      account: 'hcs/account',
      hcsClient: 'hcs/client',
    }),
    tradeContractsView() {
      return this.tradeContracts;
    },
    tradeContractsViewFiltered() {
      const textFilter = tc => {
        const f = this.filterText;
        if(f) {
          return tc.id.includes(f) ||
              tc.name.includes(f) ||
              tc.tradeContractSource.dataComponentModelName?.includes(f) ||
              tc.companionOwnerName?.includes(f) ||
              this.formatDate(tc.createdAt).includes(f);
        } else {
          return true;
        }
      };
      return this.tradeContractsView.filter(tc => this.tradeContractFilter(tc) && textFilter(tc));
    }
  },
  methods: {
    async load() {
      this.tradeContracts = [];
      const {data: tradeContracts} = await this.hcsClient.get('/trade_contracts', {
        params: {'q[status_eq_any]': ['suspended', 'private']}
      });
      this.tradeContracts = tradeContracts.map(tc => createTradeContractView(tc, this.$store));
    },
  },
}
</script>
